import { Box, Container, Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import Footer from '../../components/Footer';
import Nav from '../../components/Nav/Nav';

type MainLayoutProps = {
  children: ReactNode;
};

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <Flex h="100%" minH="100vh" flexDirection="column">
      <Box>
        <Nav />
      </Box>
      <Container p={{ base: '0px', md: 'initial' }} flexGrow={1}>
        {children}
      </Container>
      <Footer />
    </Flex>
  );
};

export default MainLayout;
